module.exports = __webpack_public_path__ + "649614c34cb1aaa227bd7e72460c32fd.woff2";